import Slider from "./slider";

let fixedScroll = function () {
	if (jQuery('header#header > div.topbar').length > 0) {
		var myHeight = jQuery('header#header div.topbar').outerHeight();
		if (jQuery(this).scrollTop() > myHeight) {
			jQuery('body').addClass('fixed');
		} else {
			jQuery('body').removeClass('fixed');
		}
	}
}
fixedScroll();

jQuery(window).scroll(fixedScroll);
jQuery(document).ready(function () {
	fixedScroll();
	new Slider();
})
